/**
 * Bulk selection replace sent through single-value onChange
 * (e.g. uncheck-one-from-all). Kept free of React/DOM imports so lib code
 * such as flightUtils can decode values without pulling in window-dependent
 * breakpoint helpers.
 */

export const FILTER_PANEL_SET_PREFIX = '__filter_set__:'

export function encodeFilterPanelSet(values: Array<string>) {
  return `${FILTER_PANEL_SET_PREFIX}${JSON.stringify(values)}`
}

export function tryDecodeFilterPanelSet(value: string): Array<string> | undefined {
  if (!value.startsWith(FILTER_PANEL_SET_PREFIX)) {
    return undefined
  }

  try {
    const parsed = JSON.parse(value.slice(FILTER_PANEL_SET_PREFIX.length))
    if (!Array.isArray(parsed)) {
      return undefined
    }
    return parsed.map(String)
  } catch {
    return undefined
  }
}
